import React from 'react';
import { FiChevronLeft } from 'react-icons/fi';
import { saveAs } from 'file-saver';
import { LuDownload } from 'react-icons/lu';
import { FaFilePdf } from 'react-icons/fa6';
import { FaCirclePlay } from 'react-icons/fa6';
import { MdVideoLibrary } from "react-icons/md";
import { PiFileDocLight } from "react-icons/pi";
function MedicalRecord({ closeFunction, data }) {
  console.log(data);
  console.log(data.record.Details);
  return (
    <section className="fixed top-0 left-0 min-h-screen h-screen w-full bg-white z-30 xl:bg-black/25 xl:flex xl:justify-center xl:items-center">
      <div className="bg-white relative p-4 pt-0 z-20 m-auto overflow-y-auto scrollbar w-full h-full max-h-screen lg:max-w-4xl xl:max-w-5xl lg:py-4 lg:px-8 lg:max-h-[96vh]  lg:rounded-3xl xl:bg-bodybackground overscroll-contain">
        <div className=" bg-white flex items-center sticky top-0 py-4 z-30 xl:bg-inherit">
          <div className="flex items-center gap-1">
            <FiChevronLeft
              className="text-2xl text-coalBlack w-9 h-9 p-1 rounded-full active:bg-sky-50"
              onClick={closeFunction}
            />
            <p className="subHeadingText text-coalBlack capitalize">
              All Records
            </p>
          </div>
          <p
            className="text-navLink baseText font-medium min-w-10 p-2 cursor-pointer hidden xl:block ms-auto"
            onClick={closeFunction}
          >
            close
          </p>
        </div>
        <main className="pb-20 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 place-content-center">
          {data.record.Details.length == 0 ? (
            <p className="my-20 text-base font-normal text-coalBlack text-center lg:col-span-3 min-h-[60vh]">
              No records Uploaded
            </p>
          ) : (
            data?.record?.Details.map((file, index) => (
              <MrCard file={file} datarecords={data} />
            ))
          )}
        </main>
      </div>
    </section>
  );
}

function MrCard({ file, datarecords }) {
  let pdfFile = file.fileName.includes('pdf' || 'PDF');
  let docFile = file.fileName.includes('doc' || 'docx');
  function getreporttypeText() {
    const text = {
      report: 'Report',
      prescription: 'Prescription',
      notes: 'Notes',
    };
    return text[file?.type];
  }
  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'long', day: '2-digit' };
    return date.toLocaleDateString('en-US', options);
  }
  console.log(file.filePath);
  console.log(file);
 
  return (
    <div className="flex items-start gap-3 p-2.5 shadow-blue_dropshadow rounded-sm bg-white relative">
      {pdfFile ? (
        <div className="size-16 flex items-center pt-1 justify-center h-full">
          <FaFilePdf className="text-2xl text-red-500" />
        </div>
      ) : docFile ? (
        <div className="size-16 flex items-center pt-1 justify-center h-full">
         <PiFileDocLight className="text-2xl text-blue-500" />
        </div>
      ) : (
        <div className="size-16 basis-16 bg-gray-100 rounded-xl">
          {file?.fileType == 'video' ? (
            <div className="flex justify-center items-center h-full">
             <MdVideoLibrary className="text-2xl text-green-500 m-auto" />
            </div>
          ) : (
            <img
              src={`${process.env.REACT_APP_API_URL}/${file?.filePath}`}
              className="size-16 rounded-xl bg-navLink object-cover"
              alt={file?.fileName}
            />
          )}
        </div>
      )}
      <div className="space-y-1">
        <p className="text-black baseText max-w-[18ch] whitespace-nowrap truncate">
          Medical {getreporttypeText()}
        </p>
        <p className="text-navLink smallText">
          {formatDate(datarecords?.createdAt)}
        </p>
        <p className="text-center smallText !font-medium text-accent bg-lightBlue rounded-md px-4 py-1.5 inline-block">
          {getreporttypeText()}
        </p>
      </div>
      <button
        className="ms-auto size-10 flex justify-center items-center rounded-full active:bg-gray-100"
        onClick={() => saveAs(file.filePath ? `${process.env.REACT_APP_API_URL}/${file.filePath}`:
          '', file.fileName)}
      >
        <LuDownload className="text-xl text-navLink" />
      </button>
    </div>
  );
}

export default MedicalRecord;
